// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8ab238a","239":"cc1c373a","453":"2073a5d2","732":"d690d908"}[chunkId] + ".chunk.js";
};